const GoogleAnalytics = {
  sendEvent (hitType, category, action, { label, value } = {}) {
    if (window.ga && window._envGaTrackerNames) {
      const data = {
        hitType,
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
      }

      window._envGaTrackerNames.forEach(t => window.ga(`${t}.send`, data))
    }
  }
}

export default GoogleAnalytics
